import { defineMessages } from 'react-intl';

export const messages: {
	notificationsWithCount: { defaultMessage: string; description: string; id: string };
	overNineNotifications: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	notificationsWithCount: {
		defaultMessage:
			'{count, plural, =0 {Notifications} one {{count, number} Notification} other {{count, number} Notifications}}',
		description:
			'Accessible label for the notifications button that includes the current unread notification count.',
		id: 'global-top-navigation.notifications.notificationsWithCount',
	},
	overNineNotifications: {
		defaultMessage: 'Over 9 Notifications',
		description:
			'Accessible label for the notifications button when there are more than nine unread notifications.',
		id: 'global-top-navigation.notifications.overNineNotifications',
	},
});
